/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Document on Azure Functions
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  OggRequestContext,
} from '../models';
import {
    OggRequestContextFromJSON,
    OggRequestContextToJSON,
} from '../models';

export interface StreamAnalyzeWorkItemRequest {
    xAccessTokenType: StreamAnalyzeWorkItemXAccessTokenTypeEnum;
    xOggUserEmail: string;
    xWorkItemId: string;
    oggRequestContext: OggRequestContext;
}

export interface StreamMakeSuggestionBasedOnWorkItemRequest {
    xAccessTokenType: StreamMakeSuggestionBasedOnWorkItemXAccessTokenTypeEnum;
    xOggUserEmail: string;
    xWorkItemId: string;
    oggRequestContext: OggRequestContext;
}

export interface StreamRaterRequest {
    xAccessTokenType: StreamRaterXAccessTokenTypeEnum;
    xOggUserEmail: string;
    xWorkItemId: string;
    oggRequestContext: OggRequestContext;
}

export interface StreamScribeRequest {
    xAccessTokenType: StreamScribeXAccessTokenTypeEnum;
    xOggUserEmail: string;
    xWorkItemId: string;
    oggRequestContext: OggRequestContext;
}

export interface StreamSherpaRequest {
    xAccessTokenType: StreamSherpaXAccessTokenTypeEnum;
    xOggUserEmail: string;
    xWorkItemId: string;
    oggRequestContext: OggRequestContext;
}

/**
 * 
 */
export class StreamingApi extends runtime.BaseAPI {

    /**
     */
    async streamAnalyzeWorkItemRaw(requestParameters: StreamAnalyzeWorkItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.xAccessTokenType === null || requestParameters.xAccessTokenType === undefined) {
            throw new runtime.RequiredError('xAccessTokenType','Required parameter requestParameters.xAccessTokenType was null or undefined when calling streamAnalyzeWorkItem.');
        }

        if (requestParameters.xOggUserEmail === null || requestParameters.xOggUserEmail === undefined) {
            throw new runtime.RequiredError('xOggUserEmail','Required parameter requestParameters.xOggUserEmail was null or undefined when calling streamAnalyzeWorkItem.');
        }

        if (requestParameters.xWorkItemId === null || requestParameters.xWorkItemId === undefined) {
            throw new runtime.RequiredError('xWorkItemId','Required parameter requestParameters.xWorkItemId was null or undefined when calling streamAnalyzeWorkItem.');
        }

        if (requestParameters.oggRequestContext === null || requestParameters.oggRequestContext === undefined) {
            throw new runtime.RequiredError('oggRequestContext','Required parameter requestParameters.oggRequestContext was null or undefined when calling streamAnalyzeWorkItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xAccessTokenType !== undefined && requestParameters.xAccessTokenType !== null) {
            headerParameters['x-access-token-type'] = String(requestParameters.xAccessTokenType);
        }

        if (requestParameters.xOggUserEmail !== undefined && requestParameters.xOggUserEmail !== null) {
            headerParameters['x-ogg-user-email'] = String(requestParameters.xOggUserEmail);
        }

        if (requestParameters.xWorkItemId !== undefined && requestParameters.xWorkItemId !== null) {
            headerParameters['x-work-item-id'] = String(requestParameters.xWorkItemId);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stream/analyze`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OggRequestContextToJSON(requestParameters.oggRequestContext),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async streamAnalyzeWorkItem(requestParameters: StreamAnalyzeWorkItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.streamAnalyzeWorkItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async streamMakeSuggestionBasedOnWorkItemRaw(requestParameters: StreamMakeSuggestionBasedOnWorkItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.xAccessTokenType === null || requestParameters.xAccessTokenType === undefined) {
            throw new runtime.RequiredError('xAccessTokenType','Required parameter requestParameters.xAccessTokenType was null or undefined when calling streamMakeSuggestionBasedOnWorkItem.');
        }

        if (requestParameters.xOggUserEmail === null || requestParameters.xOggUserEmail === undefined) {
            throw new runtime.RequiredError('xOggUserEmail','Required parameter requestParameters.xOggUserEmail was null or undefined when calling streamMakeSuggestionBasedOnWorkItem.');
        }

        if (requestParameters.xWorkItemId === null || requestParameters.xWorkItemId === undefined) {
            throw new runtime.RequiredError('xWorkItemId','Required parameter requestParameters.xWorkItemId was null or undefined when calling streamMakeSuggestionBasedOnWorkItem.');
        }

        if (requestParameters.oggRequestContext === null || requestParameters.oggRequestContext === undefined) {
            throw new runtime.RequiredError('oggRequestContext','Required parameter requestParameters.oggRequestContext was null or undefined when calling streamMakeSuggestionBasedOnWorkItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xAccessTokenType !== undefined && requestParameters.xAccessTokenType !== null) {
            headerParameters['x-access-token-type'] = String(requestParameters.xAccessTokenType);
        }

        if (requestParameters.xOggUserEmail !== undefined && requestParameters.xOggUserEmail !== null) {
            headerParameters['x-ogg-user-email'] = String(requestParameters.xOggUserEmail);
        }

        if (requestParameters.xWorkItemId !== undefined && requestParameters.xWorkItemId !== null) {
            headerParameters['x-work-item-id'] = String(requestParameters.xWorkItemId);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stream/suggest`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OggRequestContextToJSON(requestParameters.oggRequestContext),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async streamMakeSuggestionBasedOnWorkItem(requestParameters: StreamMakeSuggestionBasedOnWorkItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.streamMakeSuggestionBasedOnWorkItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async streamRaterRaw(requestParameters: StreamRaterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.xAccessTokenType === null || requestParameters.xAccessTokenType === undefined) {
            throw new runtime.RequiredError('xAccessTokenType','Required parameter requestParameters.xAccessTokenType was null or undefined when calling streamRater.');
        }

        if (requestParameters.xOggUserEmail === null || requestParameters.xOggUserEmail === undefined) {
            throw new runtime.RequiredError('xOggUserEmail','Required parameter requestParameters.xOggUserEmail was null or undefined when calling streamRater.');
        }

        if (requestParameters.xWorkItemId === null || requestParameters.xWorkItemId === undefined) {
            throw new runtime.RequiredError('xWorkItemId','Required parameter requestParameters.xWorkItemId was null or undefined when calling streamRater.');
        }

        if (requestParameters.oggRequestContext === null || requestParameters.oggRequestContext === undefined) {
            throw new runtime.RequiredError('oggRequestContext','Required parameter requestParameters.oggRequestContext was null or undefined when calling streamRater.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xAccessTokenType !== undefined && requestParameters.xAccessTokenType !== null) {
            headerParameters['x-access-token-type'] = String(requestParameters.xAccessTokenType);
        }

        if (requestParameters.xOggUserEmail !== undefined && requestParameters.xOggUserEmail !== null) {
            headerParameters['x-ogg-user-email'] = String(requestParameters.xOggUserEmail);
        }

        if (requestParameters.xWorkItemId !== undefined && requestParameters.xWorkItemId !== null) {
            headerParameters['x-work-item-id'] = String(requestParameters.xWorkItemId);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stream/rater`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OggRequestContextToJSON(requestParameters.oggRequestContext),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async streamRater(requestParameters: StreamRaterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.streamRaterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async streamScribeRaw(requestParameters: StreamScribeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.xAccessTokenType === null || requestParameters.xAccessTokenType === undefined) {
            throw new runtime.RequiredError('xAccessTokenType','Required parameter requestParameters.xAccessTokenType was null or undefined when calling streamScribe.');
        }

        if (requestParameters.xOggUserEmail === null || requestParameters.xOggUserEmail === undefined) {
            throw new runtime.RequiredError('xOggUserEmail','Required parameter requestParameters.xOggUserEmail was null or undefined when calling streamScribe.');
        }

        if (requestParameters.xWorkItemId === null || requestParameters.xWorkItemId === undefined) {
            throw new runtime.RequiredError('xWorkItemId','Required parameter requestParameters.xWorkItemId was null or undefined when calling streamScribe.');
        }

        if (requestParameters.oggRequestContext === null || requestParameters.oggRequestContext === undefined) {
            throw new runtime.RequiredError('oggRequestContext','Required parameter requestParameters.oggRequestContext was null or undefined when calling streamScribe.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xAccessTokenType !== undefined && requestParameters.xAccessTokenType !== null) {
            headerParameters['x-access-token-type'] = String(requestParameters.xAccessTokenType);
        }

        if (requestParameters.xOggUserEmail !== undefined && requestParameters.xOggUserEmail !== null) {
            headerParameters['x-ogg-user-email'] = String(requestParameters.xOggUserEmail);
        }

        if (requestParameters.xWorkItemId !== undefined && requestParameters.xWorkItemId !== null) {
            headerParameters['x-work-item-id'] = String(requestParameters.xWorkItemId);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stream/scribe`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OggRequestContextToJSON(requestParameters.oggRequestContext),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async streamScribe(requestParameters: StreamScribeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.streamScribeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async streamSherpaRaw(requestParameters: StreamSherpaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.xAccessTokenType === null || requestParameters.xAccessTokenType === undefined) {
            throw new runtime.RequiredError('xAccessTokenType','Required parameter requestParameters.xAccessTokenType was null or undefined when calling streamSherpa.');
        }

        if (requestParameters.xOggUserEmail === null || requestParameters.xOggUserEmail === undefined) {
            throw new runtime.RequiredError('xOggUserEmail','Required parameter requestParameters.xOggUserEmail was null or undefined when calling streamSherpa.');
        }

        if (requestParameters.xWorkItemId === null || requestParameters.xWorkItemId === undefined) {
            throw new runtime.RequiredError('xWorkItemId','Required parameter requestParameters.xWorkItemId was null or undefined when calling streamSherpa.');
        }

        if (requestParameters.oggRequestContext === null || requestParameters.oggRequestContext === undefined) {
            throw new runtime.RequiredError('oggRequestContext','Required parameter requestParameters.oggRequestContext was null or undefined when calling streamSherpa.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xAccessTokenType !== undefined && requestParameters.xAccessTokenType !== null) {
            headerParameters['x-access-token-type'] = String(requestParameters.xAccessTokenType);
        }

        if (requestParameters.xOggUserEmail !== undefined && requestParameters.xOggUserEmail !== null) {
            headerParameters['x-ogg-user-email'] = String(requestParameters.xOggUserEmail);
        }

        if (requestParameters.xWorkItemId !== undefined && requestParameters.xWorkItemId !== null) {
            headerParameters['x-work-item-id'] = String(requestParameters.xWorkItemId);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stream/sherpa`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OggRequestContextToJSON(requestParameters.oggRequestContext),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async streamSherpa(requestParameters: StreamSherpaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.streamSherpaRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const StreamAnalyzeWorkItemXAccessTokenTypeEnum = {
    Ado: 'ado',
    WorkOS: 'workos',
    Jira: 'jira',
    Test: 'test'
} as const;
export type StreamAnalyzeWorkItemXAccessTokenTypeEnum = typeof StreamAnalyzeWorkItemXAccessTokenTypeEnum[keyof typeof StreamAnalyzeWorkItemXAccessTokenTypeEnum];
/**
 * @export
 */
export const StreamMakeSuggestionBasedOnWorkItemXAccessTokenTypeEnum = {
    Ado: 'ado',
    WorkOS: 'workos',
    Jira: 'jira',
    Test: 'test'
} as const;
export type StreamMakeSuggestionBasedOnWorkItemXAccessTokenTypeEnum = typeof StreamMakeSuggestionBasedOnWorkItemXAccessTokenTypeEnum[keyof typeof StreamMakeSuggestionBasedOnWorkItemXAccessTokenTypeEnum];
/**
 * @export
 */
export const StreamRaterXAccessTokenTypeEnum = {
    Ado: 'ado',
    WorkOS: 'workos',
    Jira: 'jira',
    Test: 'test'
} as const;
export type StreamRaterXAccessTokenTypeEnum = typeof StreamRaterXAccessTokenTypeEnum[keyof typeof StreamRaterXAccessTokenTypeEnum];
/**
 * @export
 */
export const StreamScribeXAccessTokenTypeEnum = {
    Ado: 'ado',
    WorkOS: 'workos',
    Jira: 'jira',
    Test: 'test'
} as const;
export type StreamScribeXAccessTokenTypeEnum = typeof StreamScribeXAccessTokenTypeEnum[keyof typeof StreamScribeXAccessTokenTypeEnum];
/**
 * @export
 */
export const StreamSherpaXAccessTokenTypeEnum = {
    Ado: 'ado',
    WorkOS: 'workos',
    Jira: 'jira',
    Test: 'test'
} as const;
export type StreamSherpaXAccessTokenTypeEnum = typeof StreamSherpaXAccessTokenTypeEnum[keyof typeof StreamSherpaXAccessTokenTypeEnum];
